import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";

@Component({
    selector: "rask-planera-tabs",
    templateUrl: "./planera-tabs.component.html",
    styleUrls: ["./planera-tabs.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent
    ]
})
export class PlaneraTabsComponent {

    @Input() tabs: IPlaneraTab[];
    @Output() tabChanged: EventEmitter<IPlaneraTab> = new EventEmitter<IPlaneraTab>();

    get visibleTabs(): IPlaneraTab[] {
        return this.tabs.filter(p => !p.hidden);
    }

    setTab(tab: IPlaneraTab) {
        this.tabChanged.emit(tab);
    }
}

export interface IPlaneraTab {
    id: string;
    name: string;
    hidden: boolean;
}
